module.exports = __webpack_public_path__ + "static/img/proImg4.b977017.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/proImg4.png
// module id = r+fK
// module chunks = 1